<template>
  <div id="app">
    <AppHeader v-if="showHeader" ref="header" />
    <main>
      <router-view />
    </main>
    <AppFooter v-if="showFooter" />
  </div>
</template>

<script>
import AppHeader from './components/Header.vue'
import AppFooter from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  },
  data () {
    return {
      user: null
    }
  },
  computed: {
    showHeader () {
      return this.$route.meta.showHeader !== false
    },
    showFooter () {
      return this.$route.meta.showFooter !== false
    }
  },
  provide () {
    return {
      app: this
    }
  },
  mounted () {
    const savedUser = localStorage.getItem('user')
    if (savedUser) {
      this.user = JSON.parse(savedUser)
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', 'Microsoft YaHei', Tahoma, Geneva, Verdana, sans-serif;
}

body {
  background-color: #f5f7fa;
  color: #333;
  line-height: 1.6;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

/* 通用容器 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

/* 通用主按钮（蓝白） */
.btn-primary {
  background-color: #2444cb;
  color: #fff;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-primary:hover {
  background-color: #1a36a8;
}

@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }
}
</style>
